/* iframe youtube
------------------------------------------ */
$(function(){

  function videoControl(action){
    var $playerWindow = $('#youtube-iframe')[0].contentWindow;
    $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
  }

  $('.ytiframe-playbtn').on('click', function(){
    $(this).hide();
　　videoControl('playVideo');
  });


});
